import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { t } from '../../lang';
import RequestService from '../../services/RequestService';
import StorageService from '../../services/StorageService';
import TypesService from '../../services/TypesService';
import { appSlice } from '../../store/slices';
import Button from '../Button';

import './FeePaymentMethod.scss';

const TRX_ID = 2;
const CREDIT_CURRENCY_ID = 8;
const BlockchainsById = TypesService.BlockchainsById;
const CurrenciesById = TypesService.CurrenciesById;

const FeePaymentMethod = ({ feeByCurrencyId, account, feeData, setFeeData }) => {
	const emptyTrxMethod = {
		Amount: 0,
		AmountUsd: 0,
		CurrencyId: TRX_ID,
		Fee: feeByCurrencyId[TRX_ID],
	};
	const [trxMethod, setTrxMethod] = useState(emptyTrxMethod);

	const quotes = useSelector(store => store.app.quotes);
	const billingBalance = useSelector(state => state.app.billingBalance);
	const tariffData = useSelector(store => store.app.tariffData);

	const dispatch = useDispatch();

	const ratesByCurrencyId = quotes.reduce((acc, quote) => {
		acc[quote.Id] = quote.Rate;
		return acc;
	}, {});

	const billingMethod = {
		Amount: billingBalance,
		AmountUsd: billingBalance * ratesByCurrencyId[CREDIT_CURRENCY_ID],
		BlockchainId: BlockchainsById[CurrenciesById[CREDIT_CURRENCY_ID].BlockchainId].Id,
		CurrencyId: CREDIT_CURRENCY_ID,
		Fee: feeByCurrencyId[CREDIT_CURRENCY_ID],
	};

	const sendingAccountMethod = {
		...account,
		CurrencyId: account.CurrencyId,
		Fee: feeByCurrencyId[account.CurrencyId],
	};

	const methods = [sendingAccountMethod, billingMethod, trxMethod];
	const sortedMethods = [...methods].sort((a, b) => b.AmountUsd - a.AmountUsd);

	const selectMethod = method => {
		setFeeData(method);
	};

	const getTrxGsBalance = useCallback(async addressId => {
		try {
			const response = await RequestService.GetAddressGSBalance(addressId);

			if (response.Status === 'Success') {
				const activeGsStation = response.GasStations.find(station => station.IsActive);
				setTrxMethod(trxMethod => ({ ...trxMethod, GsBalance: activeGsStation?.Balance }));
			}
		} catch (error) {
			console.log('error', error);
		}
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	const getTrxAddresses = useCallback(async () => {
		try {
			const response = await RequestService.GetAddressesByCurrency(TRX_ID);

			const accountTrxAddress = response.Addresses.find(({ Address }) => Address === account.Address) || {};

			const trxAddress = { ...emptyTrxMethod, ...accountTrxAddress };

			setTrxMethod(trxAddress);

			if (trxAddress?.Amount < feeByCurrencyId[TRX_ID]) getTrxGsBalance(accountTrxAddress.AddressId);
		} catch (error) {
			console.log('error', error);
		}
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		getTrxAddresses();
		StorageService.UpdateTariffList();
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		if (!feeData.CurrencyId) {
			selectMethod(billingBalance >= feeByCurrencyId[CREDIT_CURRENCY_ID] ? billingMethod : sendingAccountMethod);
		}
	}, [tariffData]); // eslint-disable-line react-hooks/exhaustive-deps

	const changeMethod = () => {
		dispatch(
			appSlice.actions.addModal({
				title: t('Fee payment method'),
				tag: 'ChangeFeePaymentMethod',
				isOpen: true,
				height: '50%',
				outsideParams: { methods: sortedMethods, selectMethod },
			})
		);
	};

	return (
		<Button className='FeePaymentMethod' onClick={changeMethod} styleType='white' iconAfter={'ARROW_CHEVRON'}>
			{t('Choose fee payment method')}
		</Button>
	);
};

export default FeePaymentMethod;
